import { createSlice } from '@reduxjs/toolkit';
import { createToppingsCategoryItem, findToppingsCategoryItem, getToppingsCategoryItem } from './api';
import { initialState } from './api/interface';

const toppingsCategoryItemSlice = createSlice({
  name: 'toppingsCategoryItem',
  initialState,
  reducers: {
    setLimit: (state, action) => {
      state.limit = action.payload.limit;
      state.status = 'idle';
    },
    setSkip: (state, action) => {
      state.skip = action.payload.skip;
      state.status = 'idle';
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload.currentPage;
    },
    setStatus: (state, action) => {
      state.status = action.payload.status;
    },
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(findToppingsCategoryItem.pending, (state) => {
      state.isLoading = true;
      state.status = 'pending';
    });
    builder.addCase(findToppingsCategoryItem.fulfilled, (state, action) => {
      state.data = action.payload.data;
      state.totalRecords = action.payload.total;
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
      state.status = 'succeeded';
    });
    builder.addCase(findToppingsCategoryItem.rejected, (state, _) => {
      state.data = [];
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.status = 'failed';
    });
    builder.addCase(createToppingsCategoryItem.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(createToppingsCategoryItem.fulfilled, (state, action) => {
      state.data.push(action.payload);
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
    });
    builder.addCase(createToppingsCategoryItem.rejected, (state, _) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
    });
    builder.addCase(getToppingsCategoryItem.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getToppingsCategoryItem.fulfilled, (state, _) => {
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
    });
    builder.addCase(getToppingsCategoryItem.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
    });
  },
});

export const { setLimit, setSkip, setCurrentPage, setStatus, reset } = toppingsCategoryItemSlice.actions;
export default toppingsCategoryItemSlice.reducer;
